import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../auth/components/auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { map, filter, take } from 'rxjs/operators';
import { OrganizationService } from '../../core/services/organization.service';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const organizationService = inject(OrganizationService);

  // Convert signal to observable
  return toObservable(authService.currentUserSignal).pipe(
    // Filter out undefined values (initial loading state)
    // filter(user => user !== undefined),
    // Take only the first non-undefined value
    take(1),
    // Map to boolean result
    map(user => {
      if (!user) {
        // Not logged in at all, redirect to login
        router.navigate(['/login'], { 
          queryParams: { returnUrl: state.url } 
        });
        return false;
      }

      const selectedOrgId = organizationService.selectedOrganizationId();

      if (selectedOrgId && authService.isAdminForOrganization(selectedOrgId)) {
        // User has admin role for the selected organization, allow access
        return true;
      } else {
        // User does not have admin role or no organization selected, redirect to home
        router.navigate(['/']);
        return false;
      }
    })
  );
};